import {block, unblock} from '../../../src/block-ui';
import {alert} from '../../../src/alerts';

$('.js-add-spider-to-order').click(function () {
    var spiderId = $(this).data('id');

    $(document).on('click.connectSpider', '.js-connect-spider', function () {
        var orderId = $(this).data('id');

        $.post('/cabinet/spider/connect/', {spiderId: spiderId, orderId: orderId}, function () {
            $(document).off('click.connectSpider');
            $.magnificPopup.close();
            window.location.reload();
        });
    });

    $.magnificPopup.open({
        items: {
            src: $('.js-spider-orders'),
            type: 'inline',
        },
    });
});

$('.js-add-spider-to-basket').click(function () {
    var spiderId = $(this).data('id');

    $.post(
        '/cabinet/spider/add-to-basket/',
        {spiderId: spiderId},
        function (response) {
            // Крестовина была добавлена в корзину
            alert(trans('spider.added_to_cart'), trans('spider.added'));

            if (typeof response.data !== 'undefined') {
                window.updateBasket(response.data);
            }
        },
        'json'
    );
});

$('.js-spider-add-form').click(function () {
    // $('.js-spider-form').toggle();
    $('.repairs-wrap').hide();
    $('.js-spider-form').show();
});

$('[name="repair_sleeve"]').click(function () {
    $('[name="sleeve_size"]').parent().toggle($('[name="repair_sleeve"]').is(':checked'));
});

$(
    '[name="repair_sleeve"], [name="restore_shaft_main"], [name="restore_shaft_second"], [name="sleeve_size"], [name="shaft_size"], [name="comment"]'
).on('blur click keyup', function (ev) {
    var toRepairSleeve = ~~$('[name="repair_sleeve"]').is(':checked');
    var toRepairShaftMain = ~~$('[name="restore_shaft_main"]').is(':checked');
    var toRepairShaftSecond = ~~$('[name="restore_shaft_second"]').is(':checked');
    var sleeveSize = $('[name="sleeve_size"]').val();
    var shaftSize = $('[name="shaft_size"]').val();

    if ((toRepairSleeve && sleeveSize) || toRepairShaftMain || toRepairShaftSecond) {
        $.post(
            '/cabinet/spider/calculate/',
            {
                repair_sleeve: toRepairSleeve,
                repair_shaft_main: toRepairShaftMain,
                repair_shaft_second: toRepairShaftSecond,
                sleeve_size: sleeveSize,
                shaft_size: shaftSize,
            },
            function (response) {
                if (!response) {
                    return;
                }

                $('.js-spider-form-error').text('').hide();
                $('.js-spider-cost').hide();

                if (response.status === 'error') {
                    $('.js-spider-form-error').text(response.message).show();
                } else {
                    $('.js-spider-cost').show();
                    $('.js-spider-cost-value').text(response.price);
                }
            },
            'json'
        );
    }
});

$('.js-spider-form').submit(function (ev) {
    ev.preventDefault();

    var decl = $('[name="decl"]').val();
    var toRepairSleeve = ~~$('[name="repair_sleeve"]').is(':checked');
    var toRepairShaftMain = ~~$('[name="restore_shaft_main"]').is(':checked');
    var toRepairShaftSecond = ~~$('[name="restore_shaft_second"]').is(':checked');
    var sleeveSize = $('[name="sleeve_size"]').val();
    var shaftSize = $('[name="shaft_size"]').val();
    var comment = $('[name="comment"]').val();

    if (!$('[name="agree"]').is(':checked')) {
        // Вы должны согласиться с правилами
        alert(trans('spider.you_can_accept_rules'));
        return;
    }

    if (decl.length !== 10 && decl.length !== 14 && decl.length !== 18) {
        // Укажите корректную декларацию
        $('.js-spider-form-error').show().text(trans('spider.specify_declaration'));
        return;
    }

    block();

    var data = {
        repair_sleeve: toRepairSleeve,
        repair_shaft_main: toRepairShaftMain,
        repair_shaft_second: toRepairShaftSecond,
        sleeve_size: sleeveSize,
        shaft_size: shaftSize,
        decl: decl,
        comment: comment,
    };

    tracker.track('Реставрация крестовин => Оформление заявки', data);

    $.post(
        '/cabinet/spider/add/',
        data,
        function (response) {
            unblock();

            if (!response) {
                return;
            }

            $('.js-spider-form-error').hide().text('');

            if (response.status === 'error') {
                $('.js-spider-form-error').text(response.message).show();
            }

            if (response.status === 'success') {
                block();

                window.location.reload();
            }
        },
        'json'
    );
});
